module.exports = __webpack_public_path__ + "pc-top-assets/img/info-ship.29bcd173.jpg";